import MicroLabel from "@/components/base/MicroLabel";

interface NotFoundTicketProps {
  requested: string;
}

/**
 * The 404 rendered as an order ticket that came back unfilled — the same
 * metaphor the whole site trades in. Fixed row rhythm so it matches the
 * "Worked example" cards on the order pages.
 */
export default function NotFoundTicket({ requested }: NotFoundTicketProps) {
  const rows = [
    { label: "Requested", value: requested, mono: true },
    { label: "Status", value: "Unfilled", accent: true },
    { label: "Reason", value: "No page rests at this address" },
    { label: "Position", value: "None opened" },
  ];

  return (
    <div className="border-2 border-primary-500 bg-background-50">
      <div className="flex flex-wrap items-center justify-between gap-x-3 gap-y-2 px-4 py-3 bg-primary-500 border-b-2 border-primary-500">
        <MicroLabel tone="default" mark="dot">
          Order ticket
        </MicroLabel>
        <MicroLabel tone="default">Nothing executed</MicroLabel>
      </div>

      <div className="divide-y-2 divide-foreground-950/15">
        {rows.map((row) => (
          <div key={row.label} className="flex items-baseline justify-between gap-4 px-4 py-3">
            <MicroLabel tone="muted" className="shrink-0">
              {row.label}
            </MicroLabel>
            {row.accent ? (
              <span className="bg-primary-500 px-2 py-1 font-label text-[10px] uppercase tracking-[0.16em] font-bold text-foreground-950 whitespace-nowrap">
                {row.value}
              </span>
            ) : (
              <span
                className={`font-label text-[11px] md:text-xs font-semibold text-foreground-950 text-right ${
                  row.mono ? "break-all" : ""
                }`}
              >
                {row.value}
              </span>
            )}
          </div>
        ))}
      </div>

      <div className="border-t-2 border-foreground-950 bg-background-100 px-4 py-3">
        <p className="text-xs leading-relaxed text-foreground-600">
          A 404 works like an unfilled order: the request left your screen, and nothing was resting
          there to match it. No harm done — just nothing to show for it.
        </p>
      </div>
    </div>
  );
}